// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'mercedes-4matic',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'MERCEDES 4MATIC',
  heroHeadingTwo: 'AWARD-WINNING INTERACTIVE STORY',
  details: [
    {
      title: 'Agency',
      items: ['Gruppo Roncaglia', 'Google Zoo'],
    },
    {
      title: 'Brand',
      items: ['Mercedes'],
    },
    {
      title: 'Platform',
      items: ['Web', 'Google APIs', 'Editions At Play'],
    },
  ],
  heading: `CREATING A DYNAMIC AND BEAUTIFUL STORYTELLING EXPERIENCE USING GOOGLE'S EDITIONS AT PLAY PLATFORM`,
  challengeImg: 'challenge.jpg',
  challenge: [
    'To create a dynamic storytelling experience of best-selling author Gianrico Carofiglio’s short story ‘The Shape of Clouds’ to showcase Mercedes’ unique ‘4Matic’ technology.',
  ],
  solutionImg: 'solution.png',
  solution: [
    'To demonstrate how 4Matic allows Mercedes vehicles to adapt to any conditions, we had to find creative ways to illustrate how Gianrico Carofiglio’s road story could adapt to the reader’s environment. The factors we used to determine the experience included location, weather conditions, potential routes, time, date and source (for example, the experience of a reader arriving from an advert, search or from YouTube were all different).',
    'The final experience has delighted author, client, agency and readers alike, delivering over 1.3 million views, and generating 5x higher lead generation rates over traditional media activity. The book has won three major Italian marketing awards and the DMA Echo International Awards in New Orleans.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: '',
      content: ['UTILISES THE VISUAL EDITIONS INTERACTIVE BOOK FORMAT AND ADAPTS TO EACH READER BASED ON MULTIPLE VARIABLES.'],
    },
    {
      img: 'callout_2.jpg',
      title: '',
      content: ['1.3 MILLION VIEWS, 56 MILLION MEDIA IMPRESSIONS, 5X HIGHER LEAD GENERATION RATES.'],
    },
    {
      img: 'callout_3.jpg',
      title: '',
      content: ['WON THREE MAJOR ITALIAN MARKETING AWARDS AND A DMA ECHO INTERNATIONAL AWARD.'],
    },
  ],
  nextCaseStudy: 'imperial',
};

export default casestudyData;
